export default "__VITE_ASSET__9yMUwPhv__"